/**
 * @file NextAuth v5认证配置
 * @description 配置NextAuth v5的认证、会话和回调
 */

import NextAuth from "next-auth";
import Google from "next-auth/providers/google";
import type { DefaultSession } from "next-auth";

// 扩展NextAuth的会话类型，包含用户ID
declare module "next-auth" {
  interface Session {
    user: {
      id: string;
    } & DefaultSession["user"];
  }
}

/**
 * 环境变量校验
 * 确保所有必要的环境变量都已设置
 * 注意：只在服务器端环境中执行此检查
 */
if (typeof window === 'undefined') { // 只在服务器端执行
  const requiredEnv = [
    'AUTH_GOOGLE_ID',
    'AUTH_GOOGLE_SECRET',
    'AUTH_SECRET',
  ];
  const missing = requiredEnv.filter((key) => !process.env[key]);
  if (missing.length > 0) {
    console.error(`缺少必要的环境变量: ${missing.join(', ')}。请检查 .env.local 配置。`);
    // 在服务器端启动时使用警告而不是抛出错误，避免阻止应用启动
    // 如果是严格要求，可以保留throw
  }
}

/**
 * NextAuth v5认证配置
 * 使用谷歌OAuth提供商处理用户登录
 */
export const { handlers, auth, signIn, signOut } = NextAuth({
  providers: [Google],
  // 自定义页面配置
  pages: {
    signIn: '/login',
  },
  session: {
    strategy: "jwt",
  },
  // 回调函数
  callbacks: {
    // 处理会话回调，在创建会话时调用
    session: ({ session, token }) => {
      if (session.user && token.sub) {
        // 将用户ID添加到会话中
        session.user.id = token.sub;
      }
      return session;
    },
  },
  debug: process.env.NODE_ENV === "development", // 在开发环境启用调试模式
  // 如需添加页面访问权限控制，可在middleware.ts中实现
}); 